import React from "react"
import { TelefoneBloqueadosContextProvider } from "./context/TelefoneBloqueadosContextProvider"
import { TelefoneBloqueados } from "./TelefoneBloqueados"

export function Index() {
    return (
        <TelefoneBloqueadosContextProvider>
            <TelefoneBloqueados />
        </TelefoneBloqueadosContextProvider>
    )
}
